import IDream from "motw_core/Entity/IDream";
import { IDreamsState } from "./IDreamsState";
import { ArrayUtils } from "source/app/services/ArrayUtils";

export function GetSearchedDreams(state: IDreamsState) {
    if (!state.searchText) {
        return state.sortedData;
    }

    const searchWords = state.searchText.split(` `);

    const wordsToFind = searchWords.filter((word) => word[0] !== `!`);

    let allDreams: IDream[] = [...state.sortedData];
    let results: IDream[] = [];

    wordsToFind.forEach((searchWord) => {
        const resultsForWord = allDreams.filter((dream) =>
            dream.name.toLowerCase().includes(searchWord.toLowerCase())
        );

        results = ArrayUtils.AddRangeToWithoutRepeating(
            results,
            resultsForWord
        );
    });

    console.log(
        `[Dreams] found ${results.length} dream(s) after searching for '${searchWords}'`
    );

    return results;
}
